import { getLocationDetails } from "@services/get_location_details";

export default function locationPredictionSelected({
  prediction,
  serviceAreaFilter,
  fns: {
    clearErrors,
    clearResults,
    keepDialogOpen,
    runDefaultBehavior,
    showNearbyLocationsPopup,
    showFixedLocationPopup,
    showSystemError,
    updateLocation,
    updateLocationLoadingStatus,
    updateSearchTerm,
  },
}: be.LocationPredictionSelectedFunctionArgs) {
  if (prediction.location) {
    clearErrors();
    clearResults();

    updateLocation(prediction.location);
  } else if (prediction.source == "title" || prediction.source == "fixedHeader") {
    keepDialogOpen();
  } else if (prediction.source == "searchMeta") {
    runDefaultBehavior(prediction);
  } else if (prediction.source == "fixedHudson") {
    runDefaultBehavior(prediction);
  } else if (prediction.source == "fixed") {
    showFixedLocationPopup(prediction.type, prediction.typestring, prediction.servicearea);
  } else if (prediction.source == "universalLocation" || prediction.source == "hudson") {
    prediction.source = "hudson";
    runDefaultBehavior(prediction);
  } else if (prediction.source == "universalGoogle") {
    prediction.source = "google";
    clearErrors();
    clearResults();
    updateSearchTerm(prediction.title);
    updateLocationLoadingStatus(true);

    getLocationDetails(prediction, serviceAreaFilter).then(
      ({
        enhancedPrediction,
        error,
        errorMessage,
        fklRequest,
        fklResponse,
        location,
        nearbyLocations,
      }) => {
        updateLocationLoadingStatus(false);

        if (error || (!location && !nearbyLocations?.length)) {
          runDefaultBehavior({
            ...prediction,
            displayName: prediction.title,
            displayAddress: prediction.description,
            error: errorMessage,
            fklRequest,
            fklResponse,
          });
        } else if (enhancedPrediction && nearbyLocations?.length) {
          showNearbyLocationsPopup(
            enhancedPrediction,
            nearbyLocations,
            location?.code ? location : undefined
          );
        } else {
          updateLocation(location);
        }
      }
    );
  }
}
